import { createSlice } from '@reduxjs/toolkit';

// Load initial state from localStorage if available
const loadState = () => {
  try {
    const serializedState = localStorage.getItem('themeSettings');
    if (serializedState === null) {
      return {
        themeMode: 'light',
        isSidebarOpen: false,
        isMobileSidebarOpen: true,
      };
    }
    // The mobile drawer always starts closed (the flag means "hidden"); only the theme and the
    // rail state carry over a reload.
    return { ...JSON.parse(serializedState), isMobileSidebarOpen: true };
  } catch (err) {
    return {
      themeMode: 'light',
      isSidebarOpen: false,
      isMobileSidebarOpen: true,
    };
  }
};

const initialState = loadState();

// Create middleware to save state changes to localStorage
const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem('themeSettings', serializedState);
  } catch (err) {
    // Handle write errors
    console.warn('Error saving state to localStorage:', err);
  }
};

const themeSettingsSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    toggleTheme: (state) => {
      state.themeMode = state.themeMode === 'light' ? 'dark' : 'light';
      saveState(state);
    },
    toggleSidebar: (state) => {
      state.isSidebarOpen = !state.isSidebarOpen;
      saveState(state);
    },
    toggleMobileSidebar: (state) => {
      state.isMobileSidebarOpen = !state.isMobileSidebarOpen;
      saveState(state);
    },
    offSidebar: (state) => {
      state.isSidebarOpen = true;
      saveState(state);
    },
  },
});

export const { toggleTheme, toggleSidebar, offSidebar, toggleMobileSidebar } =
  themeSettingsSlice.actions;
export default themeSettingsSlice.reducer;
